import { render, staticRenderFns } from "./DictionaryAcceptancesEdit.vue?vue&type=template&id=48ba8874&"
import script from "./DictionaryAcceptancesEdit.vue?vue&type=script&lang=js&"
export * from "./DictionaryAcceptancesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports